// Which server and which Cellbie domain (tenant) the app is talking to, shown under
// the login form and on the can't-reach-server page: a "Domain: dave · change" line
// when the domain came from ?d= rather than the page's host, and a "Server"
// dropdown listing config.json's backends when there is more than one. Also the
// prompt shown instead of the login page when no domain is known yet.
import { escapeHtml } from './tpl.js';
import { backend, backendChoices, chooseBackend, chooseTenant, cleanTenant } from './backend.js';

const BOX = 'max-width:330px;padding:0 15px;margin:0 auto;font-size:12px';

export function renderBackendPicker(container) {
  renderTenantLine(container);
  const choices = backendChoices();
  if (choices.length < 2) return;
  const div = document.createElement('div');
  div.className = 'form-inline text-muted';
  div.style.cssText = BOX;
  div.innerHTML =
    '<label for="wbBackendPicker" style="font-weight:normal;margin-right:6px">Server</label>' +
    '<select id="wbBackendPicker" class="form-control input-sm">' +
    choices
      .map((c) => '<option value="' + escapeHtml(c.origin) + '"' + (c.origin === backend.base ? ' selected' : '') + '>' + escapeHtml(c.label) + '</option>')
      .join('') +
    '</select>';
  div.querySelector('select').addEventListener('change', (e) => chooseBackend(e.target.value));
  container.appendChild(div);
}

function renderTenantLine(container) {
  if (!backend.tenant || backend.tenantFromHost) return;
  const div = document.createElement('div');
  div.className = 'text-muted';
  div.style.cssText = BOX + ';margin-bottom:6px';
  div.innerHTML = 'Domain: <strong>' + escapeHtml(backend.tenant) + '</strong> &middot; <a href="#" id="wbChangeTenant">change</a>';
  div.querySelector('#wbChangeTenant').addEventListener('click', (e) => {
    e.preventDefault();
    chooseTenant(null);
  });
  container.appendChild(div);
}

// Styled inline: Bootstrap and the theme are tenant assets served by wb, so none of
// them have loaded while no domain is known.
const PROMPT_CSS =
  '#wbTenantForm{max-width:330px;padding:15px;margin:4em auto 0;font:14px/1.4 system-ui,-apple-system,sans-serif;color:#333}' +
  '#wbTenantForm h4{font-size:18px;margin:0 0 8px}' +
  '#wbTenantForm p{margin:0 0 8px;color:#777}' +
  '#wbTenantForm input{display:block;width:100%;box-sizing:border-box;margin:10px 0;padding:8px 10px;font-size:15px;border:1px solid #ccc;border-radius:4px}' +
  '#wbTenantForm #wbTenantError{color:#a94442}' +
  '#wbTenantForm button{display:block;width:100%;padding:8px;font-size:15px;color:#fff;background:#337ab7;border:1px solid #2e6da4;border-radius:4px;cursor:pointer}';

export function renderTenantPrompt(container) {
  container.innerHTML =
    '<style>' + PROMPT_CSS + '</style>' +
    '<form id="wbTenantForm">' +
    '<h4>Which Cellbie domain?</h4>' +
    '<p>The first part of your Cellbie address: <em>dave</em> for dave.cellbie.app.</p>' +
    '<input type="text" name="d" required autofocus autocomplete="organization" ' +
    'autocapitalize="none" spellcheck="false" placeholder="domain" />' +
    '<p id="wbTenantError" style="display:none">That is not a usable domain name.</p>' +
    '<button type="submit">Continue</button>' +
    '</form>';
  const form = container.querySelector('#wbTenantForm');
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const value = form.elements.d.value;
    if (!cleanTenant(value) || !chooseTenant(value)) {
      container.querySelector('#wbTenantError').style.display = '';
    }
  });
  renderBackendPicker(container);
}
